import { SvgIcon, SvgIconProps } from '@mui/material'

export function TableReport(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2.75a.75.75 0 0 0-.75.75v17c0 .414.336.75.75.75h12.75V3.5a.75.75 0 0 0-.75-.75H4Zm-2.25.75A2.25 2.25 0 0 1 4 1.25h12a2.25 2.25 0 0 1 2.25 2.25V22a.75.75 0 0 1-.75.75H4a2.25 2.25 0 0 1-2.25-2.25v-17Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 11.75a.25.25 0 0 0-.25.25v9.25H20a.75.75 0 0 0 .75-.75V12a.25.25 0 0 0-.25-.25h-2Zm-1.75.25c0-.966.784-1.75 1.75-1.75h2c.966 0 1.75.784 1.75 1.75v8.5A2.25 2.25 0 0 1 20 22.75h-2.5a.75.75 0 0 1-.75-.75V12Zm-12-6a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 4.75 6Zm0 3.5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z"
        fill={props?.fill}
      />
    </SvgIcon>
  )
}

export default TableReport
